import { useContext, useEffect } from "react";
import { getAuth, onAuthStateChanged, signInWithPopup, GoogleAuthProvider } from "firebase/auth"

import { app } from "../../firebase.js";
import { Loading, Notify } from "notiflix";

import { contexto } from "../CustomProvider.js";
import { isProduction, notifyMe } from "../utils.js";
import { LogInIcon } from "lucide-react";

const auth = getAuth(app);

const LoginWithSocial = ({ show }) => {
    const { onUserLogueado, authToken } = useContext(contexto);

    const styles = {
        loginButton: {
            padding: '10px 16px',
            background: '#00a63e',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '600',
            transition: 'all 0.2s',
            marginRight: '8px'
        },
    }

    useEffect(() => {
        Loading.hourglass();

        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                Loading.remove(100);
                const { uid, displayName, email, photoURL, phoneNumber } = user;

                const usuario = {
                    uid,
                    displayName,
                    email,
                    photoURL,
                    phoneNumber,
                };

                try {
                    const token = await user.getIdToken();
                    authToken.current = token;

                    const response = await fetch(`${isProduction() ? window.location.origin : 'http://localhost:8080'}/api/user/${uid}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        }
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    const data = await response.json();

                    if (JSON.stringify(data) === '{}') {
                        const msg = `Primer inicio de ${displayName} (${uid}) en La Caja Boba 3.0`;
                        console.log({ msg })
                        notifyMe(msg);
                    }

                    onUserLogueado({
                        ...usuario,
                        ...data
                    });
                } catch (error) {
                    console.log("Error login");
                    console.log(error)
                }
            }
            else {
                Loading.remove(100);
            }
        });

        return () => unsubscribe();
    }, []);



    const handleLoginWithGoogle = () => {
        Loading.hourglass();
        const provider = new GoogleAuthProvider();
        signInWithPopup(auth, provider)
            .catch(e => {
                Notify.failure(e.code);
                Notify.failure(e.message);
            })
            .finally(() => {
                setTimeout(() => {
                    Loading.remove();
                }, 1000)
            })
    }



    if (show) {
        return (
            <button
                style={styles.loginButton}
                onClick={handleLoginWithGoogle}
                onMouseEnter={(e) => e.target.style.opacity = '0.9'}
                onMouseLeave={(e) => e.target.style.opacity = '1'}
            >
                <LogInIcon size={18} />
                Iniciar Sesión
            </button>
        );
    }

    return null;
}

export default LoginWithSocial;